import http from "../../plugins/axios";

export default {
  tree(data) {
    return http.get({
      url: "/la/admin/tenant/menu/tree",
      data,
    });
  },
  add(data) {
    return http.post({
      url: "/la/admin/tenant/menu/add",
      data,
    });
  },
  update(data) {
    return http.post({
      url: "/la/admin/tenant/menu/update",
      data,
    });
  },
  remove(data) {
    return http.post({
      url: "/la/admin/tenant/menu/delete",
      data,
      dataType: "form",
    });
  },
};
